/***
 * Library contains JavaScript API for interaction with Seeneco Framework Web Services contained in FundsPackage
 * @author AlexPlex Generated by Seeneco Framework Modeler 
 *
 */
(function(w){
/***
* 
*/
w.AccountStatement = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "ACCOUNT_STATEMENT";
  this.CopySupportingElement = false;
  this.AccountNumber = "";
  this.DateStart = null;
  this.DateFinish = null;
  this.BalanceStart = -1;
  this.BalanceFinish = -1;
  this.Items = [];
  this.AccountType = "";
  this.AccountCurrencyLetterCode = "";
  this.ID = -1;
  this.FundsRegisterID = -1;
  this.AccountSourceUID = "";
  this.SourceSystemID = -1;
  this.LegalEntityUID = "";
  this.LegalEntityName = "";
  this.LegalEntityTaxCode = "";
  this.AccountName = "";
  this.BIC = "";
};
/***
* 
*/
w.AccountStatementFileReference = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "ACCOUNT_STATEMENT_FILE_REFERENCE";
  this.CopySupportingElement = false;
  this.AccountStatementID = -1;
  this.FileTemplateGUID = "";
  this.UploadedFileName = "";
  this.UploadDateTime = null;
};
/***
* 
*/
w.AccountStatementImport = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "ACCOUNT_STATEMENT_IMPORT";
  this.CopySupportingElement = false;
  this.StatementValid = false;
  this.AddedItemsCount = -1;
  this.AccountCreated = false;
  this.ImportStatusCode = "";
  this.AccountStatementID = -1;
  this.Message = "";
  this.ChangedItemsCount = -1;
  this.RemovedItemsCount = -1;
  this.ImportStartDate = null;
  this.ImportFinishDate = null;
  this.StatementPeriodStart = null;
  this.StatementPeriodFinish = null;
  this.FundsRegisterID = -1;
};
/***
* 
*/
w.AccountStatementItem = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "ACCOUNT_STATEMENT_ITEM";
  this.CopySupportingElement = false;
  this.ItemNumber = "";
  this.ItemDate = null;
  this.Amount = -1;
  this.PayerName = "";
  this.PayerTaxCode = "";
  this.PayerAccountNumber = "";
  this.RecipientName = "";
  this.RecipientTaxCode = "";
  this.RecipientAccountNumber = "";
  this.Reference = "";
  this.ItemUID = "";
  this.Charge = false;
  this.PayerID = -1;
  this.RecipientID = -1;
  this.AccountsChartItemID = -1;
  this.PayerBankBIC = "";
  this.RecipientBankBIC = "";
  this.OptionalPaymentUID = "";
};
/***
* 
*/
w.APIAccountStatement = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "APIACCOUNT_STATEMENT";
  this.CopySupportingElement = false;
  this.PeriodStart = null;
  this.PeriodFinish = null;
  this.BalanceStart = -1;
  this.BalanceFinish = -1;
  this.Transactions = [];
  this.Account = null;
};
/***
* 
*/
w.APICashAccount = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "APICASH_ACCOUNT";
  this.CopySupportingElement = false;
  this.Name = "";
  this.Number = "";
  this.LegalEntity = null;
  this.CashAccountUID = "";
  this.CurrentBalance = -1;
  this.AccountType = "";
  this.AccountCurrencyLetterCode = "";
  this.BankName = "";
  this.BankBIC = "";
};
/***
* 
*/
w.APICashAccountAnalysis = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "APICASH_ACCOUNT_ANALYSIS";
  this.CopySupportingElement = false;
  this.TransactionClassTimeSeries = [];
  this.BalanceTimeSeries = null;
  this.ChargeTimeSeries = null;
  this.IncomeTimeSeries = null;
  this.RecipientsTimeSeries = [];
  this.PayersTimeSeries = [];
};
/***
* 
*/
w.APICashTransaction = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "APICASH_TRANSACTION";
  this.CopySupportingElement = false;
  this.TransactionDate = null;
  this.Amount = -1;
  this.Reference = "";
  this.TransactionUID = "";
  this.Charge = false;
  this.Recipient = null;
  this.Payer = null;
  this.RecipientAccount = null;
  this.PayerAccount = null;
  this.InternalTransfer = false;
};
/***
* 
*/
w.APICashTransactionAnalysis = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "APICASH_TRANSACTION_ANALYSIS";
  this.CopySupportingElement = false;
  this.Transaction = null;
  this.Classes = [];
};
/***
* 
*/
w.APICashTransactionClassTimeSeries = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "APICASH_TRANSACTION_CLASS_TIME_SERIES";
  this.CopySupportingElement = false;
  this.TransactionClass = null;
  this.Charge = false;
  this.Points = [];
  this.TotalValue = -1;
};
/***
* 
*/
w.APICounterpartyTurnoverTimeSeries = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "APICOUNTERPARTY_TURNOVER_TIME_SERIES";
  this.CopySupportingElement = false;
  this.CounterpartyName = "";
  this.CounterpartyTaxCode = "";
  this.Charge = false;
  this.Points = [];
  this.TotalValue = -1;
};
/***
* 
*/
w.APITimeSeries = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "APITIME_SERIES";
  this.CopySupportingElement = false;
  this.Points = [];
  this.TotalValue = -1;
};
/***
* 
*/
w.APITimeSeriesPoint = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "APITIME_SERIES_POINT";
  this.CopySupportingElement = false;
  this.Value = -1;
  this.ValueDate = null;
};
/***
* 
*/
w.BalanceTurnoverRecalculationRequest = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "BALANCE_TURNOVER_RECALCULATION_REQUEST";
  this.CopySupportingElement = false;
  this.FundsRegisterID = -1;
  this.StartBalance = -1;
  this.OperationUID = -1;
};
/***
* 
*/
w.BankAccountFundsRegister = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "BANK_ACCOUNT_FUNDS_REGISTER";
  this.CopySupportingElement = false;
  this.Bank = null;
  this.ID = -1;
  this.Name = "";
  this.RegisterNumber = "";
  this.LegalEntity = null;
  this.CurrencyID = -1;
  this.SourceUID = "";
  this.CashManagementSystem = null;
  this.LimitedAccess = false;
  this.ExternalSystemAccountID = -1;
};
/***
* 
*/
w.CashBalanceRecord = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CASH_BALANCE_RECORD";
  this.CopySupportingElement = false;
  this.IncomingBalance = -1;
  this.OutgoingBalance = -1;
  this.ValueDate = null;
  this.Plan = false;
  this.Receipt = -1;
  this.Charge = -1;
  this.CurrencyCharge = -1;
  this.InCurrencyBalance = -1;
  this.OutCurrencyBalance = -1;
  this.CurrencyReceipt = -1;
};
/***
* 
*/
w.CashDeskFundsRegister = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CASH_DESK_FUNDS_REGISTER";
  this.CopySupportingElement = false;
  this.ID = -1;
  this.Name = "";
  this.RegisterNumber = "";
  this.LegalEntity = null;
  this.CurrencyID = -1;
  this.SourceUID = "";
  this.CashManagementSystem = null;
  this.LimitedAccess = false;
  this.ExternalSystemAccountID = -1;
};
/***
* 
*/
w.CashflowForecast = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CASHFLOW_FORECAST";
  this.CopySupportingElement = false;
  this.AnalysisDate = null;
  this.CashBalances = [];
  this.Incomes = [];
  this.Expenses = [];
};
/***
* 
*/
w.CashManagementSystem = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CASH_MANAGEMENT_SYSTEM";
  this.CopySupportingElement = false;
  this.Name = "";
  this.ID = -1;
  this.SubsystemInstanceGUID = "";
  this.TenantHasValidExternalAccount = false;
  this.SupportGetAccountList = false;
  this.RequestLegalEntityToGetAccountsList = false;
  this.SupportCreatePaymentDraft = false;
  this.SupportFastPayment = false;
};
/***
* 
*/
w.CMSAccount = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSACCOUNT";
  this.CopySupportingElement = false;
  this.AccountNumber = "";
  this.AccountType = "";
  this.AccountCurrencyLetterCode = "";
  this.UID = "";
  this.LegalEntityUID = "";
  this.LegalEntityName = "";
  this.AccountName = "";
  this.LegalEntityTaxCode = "";
  this.Status = -1;
  this.BIC = "";
  this.ExternalSystemAccountID = -1;
  this.AccountDateOpened = null;
  this.CashManagementSystem = null;
};
/***
* 
*/
w.CMSAccountImportResult = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSACCOUNT_IMPORT_RESULT";
  this.CopySupportingElement = false;
  this.CMSAccount = null;
  this.AccountStatementImport = null;
};
/***
* 
*/
w.CMSAccountListRequest = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSACCOUNT_LIST_REQUEST";
  this.CopySupportingElement = false;
  this.LegalEntityUID = "";
  this.LegalEntityName = "";
  this.LegalEntityTaxCode = "";
  this.UID = "";
  this.SandboxMode = false;
  this.CashManagementSystemID = -1;
};
/***
* 
*/
w.CMSAccountsResponse = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSACCOUNTS_RESPONSE";
  this.CopySupportingElement = false;
  this.Accounts = [];
  this.ServiceAvailable = false;
  this.AuthorizationSuccess = false;
  this.Message = "";
  this.UID = "";
  this.Status = "";
};
/***
* 
*/
w.CMSAccountStatementListRequest = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSACCOUNT_STATEMENT_LIST_REQUEST";
  this.CopySupportingElement = false;
  this.RequestList = [];
};
/***
* 
*/
w.CMSAccountStatementRequest = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSACCOUNT_STATEMENT_REQUEST";
  this.CopySupportingElement = false;
  this.CMSAccount = null;
  this.AccountStatementID = -1;
  this.DateStart = null;
  this.DateFinish = null;
  this.ServerTaskInstanceID = -1;
  this.UID = "";
  this.SandboxMode = false;
  this.CashManagementSystemID = -1;
};
/***
* 
*/
w.CMSAccountStatementRequestMessage = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSACCOUNT_STATEMENT_REQUEST_MESSAGE";
  this.CopySupportingElement = false;
  this.UID = "";
  this.SendDateTime = null;
  this.State = "";
  this.DateStart = null;
  this.DateFinish = null;
  this.StatusCheckDateTime = null;
};
/***
* 
*/
w.CMSAccountStatementResponse = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSACCOUNT_STATEMENT_RESPONSE";
  this.CopySupportingElement = false;
  this.AccountStatement = null;
  this.ServiceAvailable = false;
  this.AuthorizationSuccess = false;
  this.Message = "";
  this.UID = "";
  this.Status = "";
};
/***
* 
*/
w.CMSCreatePaymentDraftRequest = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSCREATE_PAYMENT_DRAFT_REQUEST";
  this.CopySupportingElement = false;
  this.PaymentDraftID = -1;
  this.UID = "";
  this.SandboxMode = false;
  this.CashManagementSystemID = -1;
};
/***
* 
*/
w.CMSCreatePaymentDraftResponse = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSCREATE_PAYMENT_DRAFT_RESPONSE";
  this.CopySupportingElement = false;
  this.CMSPaymentDraft = null;
  this.ServiceAvailable = false;
  this.AuthorizationSuccess = false;
  this.Message = "";
  this.UID = "";
  this.Status = "";
};
/***
* 
*/
w.CMSIntegrationStatistics = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSINTEGRATION_STATISTICS";
  this.CopySupportingElement = false;
  this.CashManagementSystemID = -1;
  this.CashManagementSystemName = "";
  this.LastImportResults = [];
};
/***
* 
*/
w.CMSPayment = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSPAYMENT";
  this.CopySupportingElement = false;
  this.PaymentAmount = -1;
  this.PaymentDate = null;
  this.Reference = "";
  this.CMSPaymentUID = "";
  this.Payer = null;
  this.Recipient = null;
  this.PayerAccount = null;
  this.RecipientAccount = null;
  this.InvoiceNumber = "";
  this.InvoiceRequiredPaymentDate = null;
  this.InternalInvoicePayment = false;
  this.SignBankURL = "";
  this.RecipientBankSystemAccountGUID = "";
  this.VatAmountIncluded = -1;
  this.VatRate = -1;
  this.SubjectToVat = false;
  this.FastSignSupport = false;
  this.InvoiceUID = "";
};
/***
* 
*/
w.CMSPaymentStatusRequest = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSPAYMENT_STATUS_REQUEST";
  this.CopySupportingElement = false;
  this.PaymentID = -1;
  this.UID = "";
  this.SandboxMode = false;
  this.CashManagementSystemID = -1;
};
/***
* 
*/
w.CMSPaymentStatusResponse = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSPAYMENT_STATUS_RESPONSE";
  this.CopySupportingElement = false;
  this.PaymentStatus = "";
  this.CMSPaymentUID = "";
  this.ServiceAvailable = false;
  this.AuthorizationSuccess = false;
  this.Message = "";
  this.UID = "";
  this.Status = "";
};
/***
* 
*/
w.CMSPaymentStatusSynchJob = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSPAYMENT_STATUS_SYNCH_JOB";
  this.CopySupportingElement = false;
  this.LastCheckDateTime = null;
  this.FirstCheckDateTime = null;
  this.StartedSecurityAgent = null;
  this.SessionTicketUID = "";
  this.ExternalSystemAccount = null;
  this.ID = -1;
  this.PaymentID = -1;
  this.UID = "";
  this.SandboxMode = false;
  this.CashManagementSystemID = -1;
};
/***
* 
*/
w.CMSRequest = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSREQUEST";
  this.CopySupportingElement = false;
  this.UID = "";
  this.SandboxMode = false;
  this.CashManagementSystemID = -1;
};
/***
* 
*/
w.CMSSendInvoiceRequest = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "CMSSEND_INVOICE_REQUEST";
  this.CopySupportingElement = false;
  this.DocumentUID = "";
  this.FundsRegisterID = -1;
  this.UID = "";
  this.SandboxMode = false;
  this.CashManagementSystemID = -1;
};
/***
* 
*/
w.FundsRegister = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "FUNDS_REGISTER";
  this.CopySupportingElement = false;
  this.ID = -1;
  this.Name = "";
  this.RegisterNumber = "";
  this.LegalEntity = null;
  this.CurrencyID = -1;
  this.SourceUID = "";
  this.CashManagementSystem = null;
  this.LimitedAccess = false;
  this.ExternalSystemAccountID = -1;
};
/***
* 
*/
w.FundsRegisterBrief = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "FUNDS_REGISTER_BRIEF";
  this.CopySupportingElement = false;
  this.Number = "";
  this.Bank = null;
  this.FundsRegisterType = null;
  this.ID = -1;
  this.Name = "";
  this.GUID = "";
};
/***
* 
*/
w.FundsRegisterEmployeeAccess = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "FUNDS_REGISTER_EMPLOYEE_ACCESS";
  this.CopySupportingElement = false;
  this.ChargeAccessLevel = -1;
  this.ReceiptAccessLevel = -1;
  this.EmployeeID = -1;
  this.FundsRegisterID = -1;
};
/***
* 
*/
w.FundsRegisterStatistics = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "FUNDS_REGISTER_STATISTICS";
  this.CopySupportingElement = false;
  this.FundsRegister = null;
  this.OutgoingBalance = -1;
  this.Receipt = -1;
  this.Charge = -1;
  this.IncomingBalance = -1;
};
/***
* 
*/
w.FundsRegisterType = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "FUNDS_REGISTER_TYPE";
  this.CopySupportingElement = false;
  this.ID = -1;
  this.Name = "";
  this.Code = "";
};
/***
* 
*/
w.GetCMSAccountStatementJob = function() {
  this.PACKAGE = "FUNDS";
  this.CLASSIFIER = "GET_CMSACCOUNT_STATEMENT_JOB";
  this.CopySupportingElement = false;
  this.Request = null;
  this.AccountStatements = [];
  this.CurrentRequestMessage = null;
  this.ID = -1;
  this.StartedSecurityAgent = null;
  this.AuditEntry = null;
  this.Completed = false;
  this.SessionTicketUID = "";
};
 
 

/***
 * Client API to CashManagementSystemServiceWS web service
 */
w.CashManagementSystemServiceClient = function() {
  /***
   * System name of target service
   */
  this.serviceName = "CashManagementSystemServiceWSImpl";
};

/***
 * [DEFAULT!!DEFAULT]
 * @param request [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.CashManagementSystemServiceClient.prototype.getAccounts = function(request, callbackHandler) {
  var parameterNames = ["request"];
  var requestJSON = JSON.stringify(request);
  var parameterValues = [requestJSON];
  var soapMessage = buildSOAPMessage("getAccounts", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param request [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.CashManagementSystemServiceClient.prototype.importAccountStatementFromCMS = function(request, callbackHandler) {
  var parameterNames = ["request"];
  var requestJSON = JSON.stringify(request);
  var parameterValues = [requestJSON];
  var soapMessage = buildSOAPMessage("importAccountStatementFromCMS", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.CashManagementSystemServiceClient.prototype.getCashManagementSystems = function(callbackHandler) {
  var parameterNames = [];
  var parameterValues = [];
  var soapMessage = buildSOAPMessage("getCashManagementSystems", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.CashManagementSystemServiceClient.prototype.refreshCMSAccounts = function(callbackHandler) {
  var parameterNames = [];
  var parameterValues = [];
  var soapMessage = buildSOAPMessage("refreshCMSAccounts", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.CashManagementSystemServiceClient.prototype.getCMSIntegrationStatistics = function(callbackHandler) {
  var parameterNames = [];
  var parameterValues = [];
  var soapMessage = buildSOAPMessage("getCMSIntegrationStatistics", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param request [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.CashManagementSystemServiceClient.prototype.sendPaymentDraft = function(request, callbackHandler) {
  var parameterNames = ["request"];
  var requestJSON = JSON.stringify(request);
  var parameterValues = [requestJSON];
  var soapMessage = buildSOAPMessage("sendPaymentDraft", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param job [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.CashManagementSystemServiceClient.prototype.processGetCMSAccountStatementJob = function(job, callbackHandler) {
  var parameterNames = ["job"];
  var jobJSON = JSON.stringify(job);
  var parameterValues = [jobJSON];
  var soapMessage = buildSOAPMessage("processGetCMSAccountStatementJob", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param request [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.CashManagementSystemServiceClient.prototype.synchronizePaymentStatus = function(request, callbackHandler) {
  var parameterNames = ["request"];
  var requestJSON = JSON.stringify(request);
  var parameterValues = [requestJSON];
  var soapMessage = buildSOAPMessage("synchronizePaymentStatus", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT][RUS!Импортировать инвойс, создать черновик платежки и отправить счет в банк!RUS]
 * @param request [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.CashManagementSystemServiceClient.prototype.sendInvoicePaymentToCMS = function(request, callbackHandler) {
  var parameterNames = ["request"];
  var requestJSON = JSON.stringify(request);
  var parameterValues = [requestJSON];
  var soapMessage = buildSOAPMessage("sendInvoicePaymentToCMS", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * Client API to FundsRegisterServiceWS web service
 */
w.FundsRegisterServiceClient = function() {
  /***
   * System name of target service
   */
  this.serviceName = "FundsRegisterServiceWSImpl";
};

/***
 * [DEFAULT!!DEFAULT]
 * @param register [DEFAULT!!DEFAULT]
 * @param initialBalance [DEFAULT!!DEFAULT]
 * @param initialDate [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.createFundsRegister = function(register, initialBalance, initialDate, callbackHandler) {
  var parameterNames = ["register", "initialBalance", "initialDate"];
  var registerJSON = JSON.stringify(register);
  var parameterValues = [registerJSON, initialBalance, initialDate];
  var soapMessage = buildSOAPMessage("createFundsRegister", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param registerID [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getFundsRegisterByID = function(registerID, callbackHandler) {
  var parameterNames = ["registerID"];
  var parameterValues = [registerID];
  var soapMessage = buildSOAPMessage("getFundsRegisterByID", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param registerID [DEFAULT!!DEFAULT]
 * @param amount [DEFAULT!!DEFAULT]
 * @param isRegisterCharged [DEFAULT!Flag  defining is register is charged by the given amoun!DEFAULT]
 * @param transactionDate [DEFAULT!!DEFAULT]
 * @param description [DEFAULT!!DEFAULT][ENG!Optional description of transaction!ENG]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.doTransaction = function(registerID, amount, isRegisterCharged, transactionDate, description, callbackHandler) {
  var parameterNames = ["registerID", "amount", "isRegisterCharged", "transactionDate", "description"];
  var parameterValues = [registerID, amount, isRegisterCharged, transactionDate, description];
  var soapMessage = buildSOAPMessage("doTransaction", parameterNames, parameterValues);
  var resultHasComplexType = false;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param balanceDate [DEFAULT!!DEFAULT]
 * @param registerID [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getOutgoingBalanceForDate = function(balanceDate, registerID, callbackHandler) {
  var parameterNames = ["balanceDate", "registerID"];
  var parameterValues = [balanceDate, registerID];
  var soapMessage = buildSOAPMessage("getOutgoingBalanceForDate", parameterNames, parameterValues);
  var resultHasComplexType = false;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param register [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.changeFundsRegister = function(register, callbackHandler) {
  var parameterNames = ["register"];
  var registerJSON = JSON.stringify(register);
  var parameterValues = [registerJSON];
  var soapMessage = buildSOAPMessage("changeFundsRegister", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param periodStart [DEFAULT!!DEFAULT]
 * @param periodEnd [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getFundsRegisterStatistics = function(periodStart, periodEnd, callbackHandler) {
  var parameterNames = ["periodStart", "periodEnd"];
  var parameterValues = [periodStart, periodEnd];
  var soapMessage = buildSOAPMessage("getFundsRegisterStatistics", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param fundsRegisterID [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.removeFundsRegister = function(fundsRegisterID, callbackHandler) {
  var parameterNames = ["fundsRegisterID"];
  var parameterValues = [fundsRegisterID];
  var soapMessage = buildSOAPMessage("removeFundsRegister", parameterNames, parameterValues);
  var resultHasComplexType = false;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param registerNumber [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getFundsRegisterByNumber = function(registerNumber, callbackHandler) {
  var parameterNames = ["registerNumber"];
  var parameterValues = [registerNumber];
  var soapMessage = buildSOAPMessage("getFundsRegisterByNumber", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param balanceDate [DEFAULT!!DEFAULT]
 * @param registerID [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getIncomingBalanceForDate = function(balanceDate, registerID, callbackHandler) {
  var parameterNames = ["balanceDate", "registerID"];
  var parameterValues = [balanceDate, registerID];
  var soapMessage = buildSOAPMessage("getIncomingBalanceForDate", parameterNames, parameterValues);
  var resultHasComplexType = false;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param accountStatement [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.importAccountStatement = function(accountStatement, callbackHandler) {
  var parameterNames = ["accountStatement"];
  var accountStatementJSON = JSON.stringify(accountStatement);
  var parameterValues = [accountStatementJSON];
  var soapMessage = buildSOAPMessage("importAccountStatement", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param accountStatementID [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getAccountStatementImport = function(accountStatementID, callbackHandler) {
  var parameterNames = ["accountStatementID"];
  var parameterValues = [accountStatementID];
  var soapMessage = buildSOAPMessage("getAccountStatementImport", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param fileReference [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.importAccountStatementFile = function(fileReference, callbackHandler) {
  var parameterNames = ["fileReference"];
  var fileReferenceJSON = JSON.stringify(fileReference);
  var parameterValues = [fileReferenceJSON];
  var soapMessage = buildSOAPMessage("importAccountStatementFile", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param analysisDate [DEFAULT!!DEFAULT]
 * @param startDate [DEFAULT!!DEFAULT]
 * @param finishDate [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getCashflowForecast = function(analysisDate, startDate, finishDate, callbackHandler) {
  var parameterNames = ["analysisDate", "startDate", "finishDate"];
  var parameterValues = [analysisDate, startDate, finishDate];
  var soapMessage = buildSOAPMessage("getCashflowForecast", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param fundsRegisterID [DEFAULT!!DEFAULT]
 * @param periodDateStart [DEFAULT!!DEFAULT]
 * @param periodDateEnd [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getAccountStatementImportsForPeriod = function(fundsRegisterID, periodDateStart, periodDateEnd, callbackHandler) {
  var parameterNames = ["fundsRegisterID", "periodDateStart", "periodDateEnd"];
  var parameterValues = [fundsRegisterID, periodDateStart, periodDateEnd];
  var soapMessage = buildSOAPMessage("getAccountStatementImportsForPeriod", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param fundsRegisterID [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getLastAccountStatementImport = function(fundsRegisterID, callbackHandler) {
  var parameterNames = ["fundsRegisterID"];
  var parameterValues = [fundsRegisterID];
  var soapMessage = buildSOAPMessage("getLastAccountStatementImport", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param fundsRegisterID [DEFAULT!!DEFAULT]
 * @param startBalance [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.recalculateFundsRegisterBalances = function(fundsRegisterID, startBalance, callbackHandler) {
  var parameterNames = ["fundsRegisterID", "startBalance"];
  var parameterValues = [fundsRegisterID, startBalance];
  var soapMessage = buildSOAPMessage("recalculateFundsRegisterBalances", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param operationUID [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getBalanceRecalculationStatus = function(operationUID, callbackHandler) {
  var parameterNames = ["operationUID"];
  var parameterValues = [operationUID];
  var soapMessage = buildSOAPMessage("getBalanceRecalculationStatus", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param fundsRegisterID [DEFAULT!!DEFAULT]
 * @param employeeAccessList [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.grantFundsRegisterAccess = function(fundsRegisterID, employeeAccessList, callbackHandler) {
  var parameterNames = ["fundsRegisterID", "employeeAccessList"];
  var employeeAccessListJSON = JSON.stringify(employeeAccessList);
  var parameterValues = [fundsRegisterID, employeeAccessListJSON];
  var soapMessage = buildSOAPMessage("grantFundsRegisterAccess", parameterNames, parameterValues);
  var resultHasComplexType = false;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param fundsRegisterID [DEFAULT!!DEFAULT]
 * @param employeeAccessList [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.denyFundsRegisterAccess = function(fundsRegisterID, employeeAccessList, callbackHandler) {
  var parameterNames = ["fundsRegisterID", "employeeAccessList"];
  var employeeAccessListJSON = JSON.stringify(employeeAccessList);
  var parameterValues = [fundsRegisterID, employeeAccessListJSON];
  var soapMessage = buildSOAPMessage("denyFundsRegisterAccess", parameterNames, parameterValues);
  var resultHasComplexType = false;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param fundsRegisterID [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getFundsRegisterAccessList = function(fundsRegisterID, callbackHandler) {
  var parameterNames = ["fundsRegisterID"];
  var parameterValues = [fundsRegisterID];
  var soapMessage = buildSOAPMessage("getFundsRegisterAccessList", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getCurrentEmployeeFundsRegisterAccess = function(callbackHandler) {
  var parameterNames = [];
  var parameterValues = [];
  var soapMessage = buildSOAPMessage("getCurrentEmployeeFundsRegisterAccess", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!Return balances for dates at period!DEFAULT]
 * @param fundsRegisterID [DEFAULT!!DEFAULT]
 * @param dateFrom [DEFAULT!!DEFAULT]
 * @param dateTo [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getCashBalancesForPeriod = function(fundsRegisterID, dateFrom, dateTo, callbackHandler) {
  var parameterNames = ["fundsRegisterID", "dateFrom", "dateTo"];
  var parameterValues = [fundsRegisterID, dateFrom, dateTo];
  var soapMessage = buildSOAPMessage("getCashBalancesForPeriod", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param fundsRegisterID [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getFundsRegisterBoundaryBalances = function(fundsRegisterID, callbackHandler) {
  var parameterNames = ["fundsRegisterID"];
  var parameterValues = [fundsRegisterID];
  var soapMessage = buildSOAPMessage("getFundsRegisterBoundaryBalances", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getLastAccountStatementImportList = function(callbackHandler) {
  var parameterNames = [];
  var parameterValues = [];
  var soapMessage = buildSOAPMessage("getLastAccountStatementImportList", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param dateFrom [DEFAULT!!DEFAULT]
 * @param dateTo [DEFAULT!!DEFAULT]
 * @param organizationIDs [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.getSummaryCashBalanceForPeriod = function(dateFrom, dateTo, organizationIDs, callbackHandler) {
  var parameterNames = ["dateFrom", "dateTo", "organizationIDs"];
  var organizationIDsJSON = JSON.stringify(organizationIDs);
  var parameterValues = [dateFrom, dateTo, organizationIDsJSON];
  var soapMessage = buildSOAPMessage("getSummaryCashBalanceForPeriod", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = true;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.clearFundsRegisterCache = function(callbackHandler) {
  var parameterNames = [];
  var parameterValues = [];
  var soapMessage = buildSOAPMessage("clearFundsRegisterCache", parameterNames, parameterValues);
  var resultHasComplexType = false;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};

/***
 * [DEFAULT!!DEFAULT]
 * @param cmsAccount [DEFAULT!!DEFAULT]
 * @param callbackHandler Function to service callback result
 */
w.FundsRegisterServiceClient.prototype.createFundsRegisterFromCMSAccount = function(cmsAccount, callbackHandler) {
  var parameterNames = ["cmsAccount"];
  var cmsAccountJSON = JSON.stringify(cmsAccount);
  var parameterValues = [cmsAccountJSON];
  var soapMessage = buildSOAPMessage("createFundsRegisterFromCMSAccount", parameterNames, parameterValues);
  var resultHasComplexType = true;
  var autoRestartOnError = false;
  callWebService(this.serviceName, soapMessage,resultHasComplexType, callbackHandler,'snc-core-services',autoRestartOnError);
};


/***
 * Package security rights constants
 */

w.FundsSecurityRights = {

    REGISTER_EMPLOYEE_ACCESS_EDIT_RIGHT:new SecurityRightCheckHandle('0b0e1f6d-a647-4592-987a-67ca6d1a2e3a'),
    REGISTER_SUPERVISION_RIGHT:new SecurityRightCheckHandle('84f4d3df-1acc-4487-ad1b-88775af9af74')
};
})(typeof exports !== 'undefined' ? exports : window);
